<template>
  <PropertyTile :label="t('task.PRIO')" class="min-h-23">
    <span class="text-body font-bold" :class="priority > 0 ? 'text-accent' : 'text-text'">
      {{ priorityLabels[`${priority}`] }}
    </span>

    <div class="mt-auto flex w-full items-center gap-1">
      <SimpleButton
        size="icon"
        variant="ghost"
        class="h-6.5 flex-1 p-0!"
        :title="t('task.PriorityLow')"
        :pressed="priority === -1"
        @click="emit('update', -1)"
      >
        <IconChevronDown16Solid class="size-3.5" />
      </SimpleButton>

      <SimpleButton
        size="icon"
        variant="ghost"
        class="h-6.5 flex-1 p-0!"
        :title="t('task.PriorityUsual')"
        :pressed="priority === 0"
        @click="emit('update', 0)"
      >
        <IconMinus16Solid class="size-3.5" />
      </SimpleButton>

      <SimpleButton
        size="icon"
        variant="ghost"
        class="h-6.5 flex-1 p-0!"
        :title="priority === 1 ? t('task.PriorityUrgent') : t('task.PriorityHigh')"
        :pressed="priority > 0"
        @click="emit('update', 1)"
      >
        <IconChevronUp16Solid v-if="priority < 2" class="size-3.5" />
        <IconChevronDoubleUp16Solid v-else class="size-3.5" />
      </SimpleButton>
    </div>
  </PropertyTile>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import SimpleButton from '@/components/elements/SimpleButton';
import {
  IconChevronDoubleUp16Solid,
  IconChevronDown16Solid,
  IconChevronUp16Solid,
  IconMinus16Solid,
} from '@iconify-prerendered/vue-heroicons';
import PropertyTile from './PropertyTile';

defineProps({
  priority: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['update']);

const { t } = useI18n();

const priorityLabels = {
  '-1': t('task.PriorityLow'),
  '0': t('task.PriorityUsual'),
  '1': t('task.PriorityHigh'),
  '2': t('task.PriorityUrgent'),
  '3': t('task.PrioritySuperUrgent'),
};
</script>
